document.addEventListener('DOMContentLoaded', function() {
  const bundleBuilder = document.querySelector('[data-bundle-builder]');
  if (!bundleBuilder) return;

  // Parse valid quantities from data attribute (e.g. "8,12,16,")
  const validQuantities = bundleBuilder.dataset.validQuantities
    .split(',')
    .filter(Boolean)
    .map(q => parseInt(q, 10))
    .sort((a, b) => a - b);

  const minQuantity = validQuantities[0] || 8;
  const maxQuantity = validQuantities[validQuantities.length - 1] || 16;

  // State
  let selectedItems = {};

  // DOM
  const slotDisplay = document.querySelector('[data-slots]');
  const tierElements = document.querySelectorAll('[data-tier]');
  const cartBtn = document.querySelector('[data-cta]');
  const cartBtnText = document.querySelector('[data-cta-text]');
  const priceOriginal = document.querySelector('[data-price-original]');
  const priceFinal = document.querySelector('[data-price-final]');

  // Build tier lookup
  const tierData = {};
  tierElements.forEach(el => {
    const qty = parseInt(el.dataset.tierQuantity, 10);
    tierData[qty] = {
      quantity: qty,
      discount: parseFloat(el.dataset.tierDiscount) || 0,
      name: el.dataset.tierName,
      element: el
    };
  });

  // ==========================================================================
  // BUNDLE CARDS
  // ==========================================================================

  const bundleCards = document.querySelectorAll('.bundle-card');
  bundleCards.forEach((card) => {
    const productId = card.dataset.productId;
    const variantId = card.dataset.variantId;
    const productTitle = card.dataset.productTitle;
    const price = parseFloat(card.dataset.productPrice);
    const qtyDisplay = card.querySelector('[data-qty]');
    const decrementBtn = card.querySelector('[data-decrement]');
    const incrementBtn = card.querySelector('[data-increment]');

    if (!selectedItems[productId]) {
      selectedItems[productId] = {
        title: productTitle,
        variantId: variantId,
        price: price,
        quantity: 0
      };
    }

    decrementBtn.addEventListener('click', () => {
      if (selectedItems[productId].quantity > 0) {
        selectedItems[productId].quantity--;
        qtyDisplay.textContent = selectedItems[productId].quantity;
        updateUI();
      }
    });

    incrementBtn.addEventListener('click', () => {
      const totalSoFar = getTotalItems();
      if (totalSoFar >= maxQuantity) {
        // Don't allow going past the max tier
        return;
      }
      selectedItems[productId].quantity++;
      qtyDisplay.textContent = selectedItems[productId].quantity;
      updateUI();
    });
  });

  // ==========================================================================
  // NUTRITION FACTS - CLICK TO OPEN MODAL (DESKTOP + MOBILE)
  // ==========================================================================

  const nutritionTriggers = document.querySelectorAll('[data-nutrition-trigger]');
  
  nutritionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const card = this.closest('.bundle-card');
      const productId = card.dataset.productId;
      const modal = document.querySelector(`[data-nutrition-modal][data-product-id="${productId}"]`);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  const closeButtons = document.querySelectorAll('[data-nutrition-close]');
  closeButtons.forEach((closeBtn) => {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      const modal = this.closest('[data-nutrition-modal]');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  // ESC key closes any open modal
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.bundle-nutrition-modal.active').forEach(modal => {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  });

  // ==========================================================================
  // HELPERS
  // ==========================================================================

  function getTotalItems() {
    let total = 0;
    for (let id in selectedItems) {
      total += selectedItems[id].quantity;
    }
    return total;
  }

  function getTotalPrice() {
    let total = 0;
    for (let id in selectedItems) {
      total += selectedItems[id].price * selectedItems[id].quantity;
    }
    return total;
  }

  function getCurrentTier(totalItems) {
    // Find the exact matching tier
    if (tierData[totalItems]) {
      return tierData[totalItems];
    }
    return null;
  }

  // ==========================================================================
  // UI UPDATE
  // ==========================================================================

  function updateUI() {
    const totalItems = getTotalItems();
    const totalPrice = getTotalPrice();

    // Update slot display
    const selectedList = [];
    for (let id in selectedItems) {
      const item = selectedItems[id];
      if (item.quantity > 0) {
        selectedList.push(`${item.quantity}× ${item.title}`);
      }
    }
    slotDisplay.innerHTML = selectedList.map(t => `<span class="bundle-builder__slot-item">${t}</span>`).join('');

    // Update tier indicators - mark as "reached" if user has hit OR passed that quantity
    tierElements.forEach(el => {
      const tierQty = parseInt(el.dataset.tierQuantity, 10);
      if (totalItems >= tierQty) {
        el.classList.add('bundle-tier--reached');
      } else {
        el.classList.remove('bundle-tier--reached');
      }
    });

    // Calculate current tier discount (only valid at exact tier match)
    const currentTier = getCurrentTier(totalItems);
    const discount = currentTier ? currentTier.discount : 0;
    const finalPrice = Math.max(0, totalPrice - discount);

    // Update prices
    if (priceOriginal) {
      if (discount > 0 && totalItems > 0) {
        priceOriginal.textContent = `$${totalPrice.toFixed(2)}`;
        priceOriginal.style.display = 'inline';
      } else {
        priceOriginal.style.display = 'none';
        priceOriginal.textContent = '';
      }
    }

    if (priceFinal) {
      priceFinal.textContent = `$${finalPrice.toFixed(2)}`;
    }

    // Update CTA - ONLY enabled at exact 8/12/16
    if (totalItems === 0) {
      cartBtn.disabled = true;
      cartBtnText.textContent = `Add ${minQuantity} more`;
    } else if (currentTier) {
      // Exact match - enable cart
      cartBtn.disabled = false;
      cartBtnText.textContent = `Add ${currentTier.name} to Cart`;
      cartBtn.onclick = (e) => {
        e.preventDefault();
        addToCart(selectedItems, currentTier);
      };
    } else if (totalItems < minQuantity) {
      cartBtn.disabled = true;
      const needed = minQuantity - totalItems;
      cartBtnText.textContent = `Add ${needed} more to reach 8-Pack`;
    } else if (totalItems > maxQuantity) {
      cartBtn.disabled = true;
      const over = totalItems - maxQuantity;
      cartBtnText.textContent = `Remove ${over} item${over > 1 ? 's' : ''}`;
    } else {
      // Between tiers (e.g. 9, 10, 11, 13, 14, 15)
      cartBtn.disabled = true;
      // Find the next tier up
      const nextTier = validQuantities.find(q => q > totalItems);
      if (nextTier) {
        const needed = nextTier - totalItems;
        cartBtnText.textContent = `Add ${needed} more to reach ${nextTier}-Pack`;
      } else {
        cartBtnText.textContent = `Adjust to 8, 12, or 16 items`;
      }
    }
  }

  // ==========================================================================
  // ADD TO CART
  // ==========================================================================

  function addToCart(items, tier) {
    const lineItems = [];
    for (let id in items) {
      const item = items[id];
      if (item.quantity > 0) {
        lineItems.push({
          id: item.variantId,
          quantity: item.quantity,
          properties: {
            '_bundle': 'true',
            '_tier': tier.name
          }
        });
      }
    }

    cartBtn.disabled = true;
    cartBtnText.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: lineItems })
    })
    .then(r => r.json())
    .then(() => { window.location.href = '/cart'; })
    .catch(err => {
      console.error('Error adding to cart:', err);
      alert('There was an error adding to your cart. Please try again.');
      cartBtn.disabled = false;
      cartBtnText.textContent = `Add ${tier.name} to Cart`;
    });
  }

  // Init
  updateUI();
});